import clsx from 'clsx';
import { formatDistanceToNowStrict } from 'date-fns';
import { AmountListItem, AmountListItemProps } from '../List';

export interface AmountSumTableItemProps
  extends Pick<
    AmountListItemProps,
    | 'amount'
    | 'title'
    | 'className'
    | 'withChevron'
    | 'subtitle'
    | 'onClick'
    | 'onKeyDown'
    | 'linkStatus'
    | 'role'
    | 'dataTestID'
    | 'contentPrefix'
    | 'motionProps'
  > {
  decayed?: boolean;
  interactive?: boolean;
  lastUpdated?: string;
  lastUpdatedPrefix?: string;
}

export function AmountSumTableItem({
  className,
  lastUpdated,
  lastUpdatedPrefix,
  decayed,
  interactive = true,
  motionProps,
  role,
  ...props
}: AmountSumTableItemProps) {
  return (
    <AmountListItem
      {...props}
      data-stale={decayed || undefined}
      tabIndex={interactive ? 0 : undefined}
      role={role ?? (interactive ? 'button' : undefined)}
      motionProps={motionProps ?? { whileFocus: { scale: 1.03, borderRadius: 8 } }}
      amountSubtitle={
        lastUpdated && (
          <div className="flex">
            <span className="MonetaryListItem-amount-subtitle mt-[1px] text-[13px] text-darkMode-gray-light/70">
              {lastUpdatedPrefix ? `${lastUpdatedPrefix} ` : ''}
              {formatDistanceToNowStrict(new Date(lastUpdated), { addSuffix: true })}
            </span>
          </div>
        )
      }
      className={clsx([
        className,
        lastUpdated || props.subtitle ? '!min-h-[56px]' : '!min-h-[48px]',
        'pl-4 first:rounded-t-2xl last:rounded-b-2xl',
        props.withChevron ? 'pr-[6px]' : 'pr-[31px]',
        '[&_.MonetaryListItem-title-content]:!my-2',
        '[&_.ListItem-chevron]:!m-0',
      ])}
    />
  );
}
